// Capability probing must not import the renderer on ordinary public pages.
export async function isWebxrSupported() {
  if (!window.isSecureContext || !navigator.xr?.isSessionSupported) return false;
  try { return await navigator.xr.isSessionSupported('immersive-ar'); }
  catch { return false; }
}
